module.exports = __webpack_public_path__ + "media/images/real-ilum-3-183b8bef50a542b2c5fd5a9dacfd5dfa.png";